module.exports = __webpack_public_path__ + "sx15-438ad5c0.png";